export default __webpack_public_path__ + "static/media/22.0461e5a4.jpg";